import CookieConsent from 'vue-cookieconsent-component';
import {
  mdiHandshake,
  mdiAccountCircle,
  mdiAccountSearch,
  mdiLogout,
  mdiAccountBoxOutline,
  mdiCellphoneArrowDown,
  mdiEmailEditOutline,
  mdiClose,
} from '@mdi/js';
import Avatar from 'vue-avatar';
import NotificationsComponent from '../NotificationsComponent/NotificationsComponent';
import EventBus from '../EventBusComponent';

export default {
  name: 'page-app',
  data: () => ({
    name_app: window.app_env.NAME,
    dialog: false,
    drawer: false,
    drawer_filter: true,
    items_main: [],
    // Only show in NavigationDrawer
    items_submenu: [],
    items_footer_navigation_drawer: [
      {
        icon: mdiAccountBoxOutline,
        text: 'Cuenta',
        location: { name: 'Account' },
        show: true,
      },
      {
        icon: mdiEmailEditOutline,
        text: 'Contacto',
        location: { name: 'ContactUs' },
        show: true,
      },
      {
        icon: mdiLogout,
        text: 'Cerrar sesión',
        action: 'logoutApp',
        show: true,
      },
    ],
    items_bar: {
      right: [],
    },

    icons: {
      mdiLogout,
      mdiAccountBoxOutline,
      mdiCellphoneArrowDown,
      mdiClose,
    },


  }),
  props: {
    source: String,
  },

  computed: {
    isAuthenticate() {
      return this.$store.getters['auth/getToken'] !== null;
    },

    updateAppClient() {
      return this.$store.getters['app/getUpdateAppClient'];
    },

    profile() {
      return this.$store.getters['auth/getProfile'];
    },

    snackbar() {
      return this.$store.getters['app/getSnackbarApp'];
    },

    isLogoutApp() {
      return this.profile === null;
    },

    showLoginNavbar() {
      return this.$route.name !== 'AuthLogin';
    },

    fullName() {
      return `${this.profile.name}  ${this.profile.surname}`;
    },

    itemsMainShow() {
      const itemsMain = [
        {
          icon: mdiAccountSearch,
          text: 'Buscar detectives',
          location: 'Users',
          show: true,
        },
        {
          icon: mdiHandshake,
          text: 'Peticiones de colaboracion',
          location: 'Collaborations',
          show: true,
        },
        {
          icon: mdiAccountCircle,
          text: 'Perfil',
          location: 'OwnProfile',
          show: this.$vuetify.breakpoint.smAndDown,
        },
        /* { icon: 'settings', text: 'Configuración', link: '/settings', },
        { icon: 'help', text: 'Ayuda', link: '/help', }, */
      ];
      return itemsMain.filter((item) => item.show);
    },

  },

  watch: {
    isLogoutApp(status) {
      if (status) {
        this.$router.push('/login');
        this.comingOut = false;
      }
    },
  },

  methods: {
    logoutApp() {
      this.$store.dispatch('auth/logoutApp');
    },

    //
    emitMethodBtnBar(event) {
      EventBus.$emit(event);
    },

    handle_function_call(fn) {
      this[fn]();
    },
    refreshApp() {
      window.location.reload(true);
    },
    hideSnackBarApp() {
      this.$store.commit('app/resetSnackBarApp', null);
    },
  },

  components: {
    CookieConsent,
    NotificationsComponent,
    Avatar,
  },

};
